import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import defaultValues from '../../constant/defaultValues';

import { getPendingMemberList, agreementPDF } from '../../actions/memberAction';

import AcSimpleTable from "../../components/AcSimpleTable";
import InputField from '../../components/InputField';
import SubHeader from '../../components/SubHeader';

import { useAuth } from '../../AuthProvider';
import { hideLoading, showLoading } from "../../actions/loaderAction";
import { ToastContainer } from "react-toastify";
import { buildPath, convertUTCToTzDate, getPrefix, showErrorMessage } from '../../utils/common';
import { size } from 'lodash';
import ToolipsCustom from '../../components/ToolipsCustom';

import LargePopupCertificate from '../../components/LargePopupCertificate';
import { privateRoutePaths } from '@/routes/private.route.config';
import roles from '@/constant/roles.config';

function Members(props) {

    const { admin, COMPANY_DEFAULTS } = defaultValues;
    const statusList = COMPANY_DEFAULTS.STATUS;
    const { user, isPreKYCUser, isDemoUser, isEndUser, isViewer, isOperationUser } = useAuth();

    const [tableKey, setTableKey] = useState(0);
    const [memberList, setMemberList] = useState([]);
    const [offset, setOffset] = useState(admin.OFFSET);
    const [limit, setLimit] = useState(admin.LIMIT);
    const [searchTxt, setSearchTxt] = useState("");
    const [loading, setLoading] = useState(false);
    const [totalRows, settotalRows] = useState(0);
    const initialRef = useRef(true);
    const [columnName, setColumnName] = useState(admin.COLUMN_NAME);
    const [sortDirection, setSortDirection] = useState(admin.SORT_DIRECTION);
    const [current_page, setCurrentPage] = useState(1);
    const [nodata, setNoData] = useState(false);
    const [largemodalShow, setLargeModalShow] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");

    const handleAgreementPDFClick = async (id) => {
        props.showLoading();

        await props.pdfToAgreementMember(id).then((response) => {
            console.log("response", response);

            if (response.status === true) {

                const pdfUrl = response.data.pdf_url;

                setPdfUrl(pdfUrl);

                setLargeModalShow(true);
                props.hideLoading();


            } else {
                console.log("False", response);
                showErrorMessage("Something went wrong!");
            }


        }).catch((err) => {
            console.log("Error ==== ", err);
            showErrorMessage("Something went wrong!");
        });
        props.hideLoading();
    }

    // const getPrefix = () => {
    //     if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    //     if (user && isDemoUser) return roles.DEMO.prefix;
    //     if (user && isEndUser) return roles.END_USER.prefix;
    //     if (user && isViewer) return roles.VIEWER.prefix;
    //     if (user && isOperationUser) return roles.OPERATION_USER.prefix;
    //     return roles.SUPER_ADMIN.prefix;
    // };

    const columns = [
        {
            name: 'Sr No',
            selector: (row, idx) => {
                return (
                    <>{offset + (idx + 1)}</>
                )
            },
            width: "5%"
        },
        {
            name: 'Orex ID',
            selector: row => <div className='text-wrap'>{row.member_unique_number}</div>,
            width: "8%",
            columnName: 'member_unique_number',
            sortable: true
        },
        {
            name: 'Company Name',
            selector: row => <div className='text-wrap'>{row.company_name}</div>,
            width: "15%",
            columnName: 'company_name',
            sortable: true
        },
        /*{
            name: 'Name',
            selector: row => <div className='text-wrap'>{row.first_name + ' ' + row.last_name}</div>,
            width: "10%",
            columnName: 'first_name',
            sortable: true
        }, */
        {
            name: 'Email',
            selector: row => <div className='text-wrap'>{row.email}</div>,
            width: "13%",
            columnName: 'email',
            sortable: true
        },
        {
            name: 'Trade Mode',
            selector: row => <div className='text-wrap'>{row.shipment_mode}</div>,
            width: "9%",
            columnName: 'shipment_mode',
            sortable: true
        },
        {
            name: 'Country',
            selector: row => <div className='text-wrap'>{row.country.name}</div>,
            width: "10%",
            columnName: "country_name",
            sortable: true
        },
        {
            name: 'Registration Date',
            selector: row => <div className='text-wrap'>{convertUTCToTzDate(row.created_at)}</div>,
            width: "11%",
            columnName: "created_at",
            sortable: true
        },
        {
            name: 'Request Date',
            selector: row => (
                <div className='text-wrap'>
                    {row.send_approval_date ? convertUTCToTzDate(row.send_approval_date) : ''}
                </div>
            ),
            width: "11%",
            columnName: "send_approval_date",
            sortable: true
        },
        {
            name: 'Status',
            selector: (row) => {
                const rowStatus = statusList.find(option => option.value === row.status);
                return rowStatus.label;
            },
            width: "10%"
            // maxWidth: '150px'
        },
        {
            name: 'Actions',
            cell: (row) => (
                <>
                    {(user.role_slug.slug === "SUP_ADM" || user.role_slug.slug === "OPERATION_USER") && (<Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: row.id + "?pending=" + btoa("ProfileReq") })}`}>

                        <ToolipsCustom
                            subtitle="Edit"
                            className="fa-regular fa-pen-to-square icon-pen border-0 "
                            classNameChild={"data-table-tooltiop"}

                        ></ToolipsCustom>
                    </Link>)
                    }

                    {
                        <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE, { id: row.id + "?pending=" + btoa("ProfileReq") })}`}>
                            <ToolipsCustom subtitle="View" className="fa-regular fa-eye icon-eyes border-0 " classNameChild={"data-table-tooltiop"}></ToolipsCustom>
                        </Link>
                    }


                    {(user.role_slug.slug === "SUP_ADM" || user.role_slug.slug === "OPERATION_USER") && row.trade_mode_type === 'LOG_PTR' && <ToolipsCustom
                        subtitle="Agreement PDF"
                        className="fa-regular fa-file-pdf border-0 panle-icon "
                        classNameChild={"data-table-tooltiop download-certificate"}
                        onClick={() => handleAgreementPDFClick(row.id)}
                    >
                    </ToolipsCustom>
                    }
                    {/* 
                    <button className="btn" >
                        <i className="fa fa-trash" aria-hidden="true"></i>
                    </button> */}
                </>
            ),
            Width: '10%'
        }
    ];

    const handleSort = async (column, sortDirection) => {
        setColumnName(column.columnName);
        setSortDirection(sortDirection);
        // getRegisteredMembers(
        //     admin.OFFSET,
        //     admin.LIMIT,
        //     current_page,
        //     column.columnName,
        //     sortDirection,
        //     searchTxt
        // );

        getRegisteredMembers(
            offset,
            limit,
            current_page,
            column.columnName,
            sortDirection,
            searchTxt
        );
    };

    const onSearchTextBoxChanged = (e) => {
        setSearchTxt(e.target.value);
        let searchVal = e.target.value;
        if (searchVal.length >= 3 || searchVal.length <= 0) {
            setOffset(admin.OFFSET);
            setLimit(admin.LIMIT);
            setColumnName(admin.COLUMN_NAME);
            setSortDirection(admin.SORT_DIRECTION);
            setTableKey((prev) => prev + 1);
            getRegisteredMembers(admin.OFFSET, admin.LIMIT, current_page, admin.COLUMN_NAME, admin.SORT_DIRECTION, e.target.value);
        }

    }


    const getRegisteredMembers = async (offset, limit, current_page, columnName, sortDirection, searchTxt) => {
        setNoData(false);
        await props.showLoading();
        await props.getPendingMembers(offset, limit, columnName, sortDirection, searchTxt).then((response) => {
            if (size(response.data) === 0) {
                setNoData(true);
            }
            setMemberList(response.data);
            settotalRows(response.metadata.total);
        }).catch((err) => {
            console.log("Error ==== ", err);
            showErrorMessage("Something went wrong");
        })
        await props.hideLoading();
    }

    useEffect(() => {
        if (initialRef.current === true) {
            initialRef.current = false;
            getRegisteredMembers(offset, limit, current_page, columnName, sortDirection, searchTxt);
        }
    }, []);


    return (<>

        <div className='data-table-main'>
            <div className="AcSimpleTable">

                <SubHeader layer1="Requests Management" layer2="Profile Requests" layer3=""
                    pageName="Profile Requests"
                    clickable={{
                        layer1: "",
                        layer2: "",
                        layer3: ""
                    }}
                />
                <div className='card1'>

                    <div className='table-header-name'>
                        <h5 className='table-text py-3'>List</h5>
                        <div className='d-flex justify-content-between align-items-center py-3'>
                            <label className='mx-3'>Search</label>
                            <InputField
                                type="text"
                                id="filter-text-box"
                                placeholder="Search..."
                                className='w-25'
                                onKeyUp={onSearchTextBoxChanged}
                                autoComplete="off"
                            ></InputField>

                            {/* <button className='export-btn'>

                            <img src={exportIcon} alt="" />
        
                            Export</button> */}

                            {/* <button className='table-add-user-button'>
                            <img src={tableAdduserIcon} alt="" /> Add New User</button> */}

                        </div>

                    </div>

                    <div className="table-wrapper">
                        <div className="table-container">
                            {memberList && (
                                <AcSimpleTable
                                    key={tableKey}
                                    data={memberList}
                                    title=""
                                    pagination={true}
                                    paginationPageSize={limit}
                                    columns={columns}
                                    progressPending={loading}
                                    paginationTotalRows={totalRows}
                                    fixedColumnsStart={admin.FIXED_COLUMNS_START}
                                    getData={getRegisteredMembers}
                                    offset={offset}
                                    limit={limit}
                                    columnName={columnName}
                                    sortDirection={sortDirection}
                                    setLimit={setLimit}
                                    setOffset={setOffset}
                                    setColumnName={setColumnName}
                                    setSortDirection={setSortDirection}
                                    setLoading={setLoading}
                                    // noDataComponent={<NoData />}
                                    paginationPerPage={limit}
                                    paginationRowsPerPageOptions={admin.PAGINATE_RANGE}
                                    // className="company-table"
                                    striped
                                    sortServer
                                    onSort={handleSort}
                                    defaultSortAsc={false}
                                    setCurrentPage={setCurrentPage}
                                    noData={nodata}
                                    searchTxt={searchTxt}
                                />
                            )}
                        </div>
                    </div>
                </div>


            </div>
            <LargePopupCertificate
                LargeModalShow={largemodalShow}
                setLargeModalShow={setLargeModalShow}
                pdfUrl={pdfUrl}
            ></LargePopupCertificate>
            {/* <ToastContainer /> */}
        </div>

    </>)
}

const mapStateToProps = state => {

    return {
        member_list: state.member.pendingMemberlist,
        // authError: state.auth.errorMessages
    }
}
const mapDispatchToProps = dispatch => {
    return {
        getPendingMembers: (offset, limit, columnName, sortDirection, searchTxt) => dispatch(getPendingMemberList(offset, limit, columnName, sortDirection, searchTxt)),
        showLoading: () => dispatch(showLoading()),
        hideLoading: () => dispatch(hideLoading()),
        pdfToAgreementMember: (id) => dispatch(agreementPDF(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Members);
